import { Show } from "solid-js";
import { createAttendnceInputs } from "../forms/form";
import * as confirm from "../apis/confirm";
import { t, type TRANSLATION_SCHEMA } from "../i18n";
import Upload from "../assets/upload.svg";
import { global } from ":shared/app";
import TermsAndConditionsModal from "./terms-and-conditions-modal";

export default function Form(props: { data: { email: string }; onDone: () => void }) {
  const Form = createAttendnceInputs();

  async function onSubmit() {
    const data = Form.Actions.getValuesSnakecase();
    return confirm.post({ ...data, email: props?.data?.email }).then(() => {
      props?.onDone?.();
    });
  }
  return (
    <section class="flex flex-col w-full h-full overflow-y-auto overflow-x-hidden pr-2 gap-2 text-16px rtl:(!pr-0 pl-2)">
      <div class="flex flex-col w-full my-5 gap-2">
        <p class="text-40px font-bold <sm:(text-30px)">{t().forms.attendance.header}</p>
        <p class="text-20px text-text-alt <sm:(text-15px)">{t().forms.attendance.brand}</p>
      </div>
      <p>{t().forms.attendance.welcome}</p>
      <Form.FullnameAr.Label title={t().forms.attendance.fields.fullname_ar.label} class="form-label">
        <Form.FullnameAr.Input type="text" class="form-input" />
      </Form.FullnameAr.Label>
      <Form.FullnameEn.Label title={t().forms.attendance.fields.fullname_en.label} class="form-label">
        <Form.FullnameEn.Input type="text" class="form-input" />
      </Form.FullnameEn.Label>
      <p>{t().forms.attendance.gratitude}</p>
      <Form.File.Label title={t().forms.attendance.fields.file.label} class="form-label">
        <div class="flex flex-col text-16px mt-2 gap-2 mb-2">{t().forms.attendance.fields.file.instruction}</div>
        <Form.File.InputFile
          accept="pdf"
          class="form-input-file taller !border-border-input !h-200px <sm:(!h-250px)"
          elements={{
            overlay({ onclick, viewer_data, drag }) {
              return (
                <div
                  onclick={onclick}
                  class="grid grid-rows-[30%_1fr] w-full h-full text-text-alt text-center justify-center items-center gap-8px cursor-pointer py-3"
                >
                  <Upload class="w-full h-full" />
                  <div class="flex flex-col py-2 overflow-hidden">
                    <Show when={!drag} fallback="Drop Files">
                      <span class="text-20px text-text">{t().forms.attendance.fields.file.click}</span>
                    </Show>
                    <span>{t().forms.attendance.fields.file.allowed}</span>
                    <span>{t().forms.attendance.fields.file.size}</span>
                    <Show when={viewer_data.file}>
                      <span class="text-brand">{viewer_data.file.name}</span>
                    </Show>
                  </div>
                </div>
              );
            },
          }}
        />
      </Form.File.Label>
      {/* checkbox */}
      <Form.AgreedAttendace.Input type="checkbox" class="form-checkbox">
        <div class="flex flex-col text-14px gap-2">
          <p class="font-bold">{t().forms.attendance.fields.checkbox_attendance.label}</p>
          <span class="">{t().forms.attendance.fields.checkbox_attendance.instruction}</span>
        </div>
      </Form.AgreedAttendace.Input>
      <Form.AgreedTerms.Input type="checkbox" class="form-checkbox mt-2">
        <div class="flex flex-col text-14px gap-2">
          <p class="font-bold">{t().forms.attendance.fields.checkbox_terms.label}</p>
          <p>{t().forms.attendance.fields.checkbox_terms.instruction(TermsAndConditions)}</p>
        </div>
      </Form.AgreedTerms.Input>
      <Form.AgreedPhoto.Input type="checkbox" class="form-checkbox mt-2">
        <div class="flex flex-col text-14px gap-2">
          <p class="font-bold">{t().forms.attendance.fields.checkbox_photo.label}</p>
          <span class="">{t().forms.attendance.fields.checkbox_photo.instruction}</span>
        </div>
      </Form.AgreedPhoto.Input>
      <Form.Actions.Button
        class="form-btn mt-2"
        onSubmit={onSubmit}
        statusValid={t().forms.global.button.valid}
        statusInvalid={t().forms.global.button.invalid}
      />
    </section>
  );
}

function TermsAndConditions(
  props: Parameters<
    Parameters<TRANSLATION_SCHEMA["forms"]["attendance"]["fields"]["checkbox_terms"]["instruction"]>[0]
  >[0]
) {
  return (
    <>
      <span>{props.start}</span>
      <span
        onclick={() => {
          // console.log("wow");
          global.store.actions.popop.pushModal({
            title: t().terms_and_conditions.title,
            startExpanded: true,
            element(props) {
              return <TermsAndConditionsModal />;
            },
          });
        }}
        class="mx-2 underline text-text-underline cursor-pointer"
      >
        {props.anchor}
      </span>
      <span>{props.end}</span>
    </>
  );
}
